import { ICategorySoldProducts } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IIsProductChecked {
  selectedData: ICategorySoldProducts[]
  categoryKey: string
  productKey: string
}

export const isProductChecked = ({ selectedData, productKey, categoryKey }: IIsProductChecked) => {
  if (!selectedData) {
    return false
  }

  const foundCategory = selectedData.find((el) => el.Key === categoryKey)

  if (foundCategory) {
    const foundProduct = foundCategory.Products?.find((el) => el.Key === productKey)
    return Boolean(foundProduct)
  }
  return false
}
